import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import LawnDevelopment from "../../components/lawn-development/LawnDevelopment";

function LawnDevelopmentPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Lawn Development Maintenance | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Lawn Development Maintenance"} t={t} />
      <LawnDevelopment />
    </>
  );
}

export default LawnDevelopmentPage;
